<div editableGroup [class.elm-pg-container]="!fullWidth">
  <div class="elm-pg-divider" [attr.style]="background"></div>
</div>
